import React from 'react';

const MobileConfirmDialog = ({
  isOpen,
  onClose,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  onConfirm,
  isLoading = false,
  error = null,
  confirmVariant = 'danger',
}) => {
  if (!isOpen) return null;

  const confirmClass =
    confirmVariant === 'danger' ? 'btn-mobile btn-danger' : 'btn-mobile btn-primary';

  return (
    <div
      className="modal-overlay center"
      style={{ zIndex: 10000 }}
      onClick={() => !isLoading && onClose()}
    >
      <div
        className="modal-mobile center"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirm-dialog-title"
      >
        <div className="modal-header">
          <h2 id="confirm-dialog-title" className="text-lg font-semibold text-gray-900 pr-6">
            {title}
          </h2>
          <button
            type="button"
            className="w-8 h-8 flex items-center justify-center rounded-full text-gray-500 touch-feedback"
            onClick={onClose}
            disabled={isLoading}
            aria-label="Close"
          >
            ×
          </button>
        </div>
        <div className="modal-content">
          {typeof message === 'string' ? (
            <p className="text-base text-gray-600 leading-relaxed">{message}</p>
          ) : (
            message
          )}
          {error && (
            <div className="mt-3 p-3 rounded-xl bg-red-50 border border-red-200 text-sm text-red-800">
              {error}
            </div>
          )}
        </div>
        <div
          className="px-4 flex flex-col sm:flex-row gap-2 sm:justify-end"
          style={{ paddingBottom: 'max(1rem, env(safe-area-inset-bottom, 0px))' }}
        >
          <button
            type="button"
            className="btn-mobile btn-secondary w-full sm:w-auto order-2 sm:order-1"
            onClick={onClose}
            disabled={isLoading}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className={`${confirmClass} w-full sm:w-auto order-1 sm:order-2`}
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? 'Please wait…' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MobileConfirmDialog;
